export type PickerKind = "Labor" | "Service" | "Fees" | "Equipment" | "Parts" | "Pricebook" | "Rebates" | "Discounts";
export type PickerCategory = { id: string; name: string; kind: string; parentCategoryId: string | null; position?: number };
export type CategorizedItem = { categoryId: string; categoryIds?: string[] };
export function pickerCategories(categories: PickerCategory[], kind: PickerKind) {
  const type = kind === "Labor" || kind === "Service" ? "service" : kind === "Parts" ? "material" : kind === "Equipment" ? "equipment" : kind === "Fees" ? "fee" : "discount";
  const importedDeductionCategory = (category: PickerCategory) =>
    kind === "Rebates" ? /rebates?|promos?/i.test(category.name) : kind === "Discounts" ? /discounts?/i.test(category.name) : false;
  // Equipment selection awaits original ServiceTitan item types from the API.
  // Category kinds alone cannot identify equipment inside shared service trees.
  // ServiceTitan labels its rebate and discount folders as Services. Keep those
  // imported folders usable without reclassifying a customer's Pricebook data.
  const typed = kind === "Pricebook" ? categories : kind === "Equipment" ? [] : categories.filter(category => category.kind === type || importedDeductionCategory(category));
  const ids = new Set(typed.map(category => category.id));
  const byId = new Map(categories.map(category => [category.id, category]));
  const path = (id: string) => {
    const names: string[] = [], visited = new Set<string>();
    let category = byId.get(id);
    while (category && !visited.has(category.id)) { visited.add(category.id); names.unshift(category.name); category = category.parentCategoryId ? byId.get(category.parentCategoryId) : undefined; }
    return names.join(" → ");
  };
  const named = (category: PickerCategory) => kind === "Labor" ? /^labou?r$/i.test(category.name.trim()) : kind === "Rebates" ? /rebates?|promos?/i.test(category.name) : /discounts?/i.test(category.name);
  const roots = kind === "Labor" || kind === "Rebates"
    ? typed.filter(named)
    : typed.filter(category => !category.parentCategoryId || !ids.has(category.parentCategoryId));
  const descendants = (rootIds: string[]) => {
    const found = new Set(rootIds);
    let count = -1;
    while (count !== found.size) { count = found.size; for (const category of typed) if (category.parentCategoryId && found.has(category.parentCategoryId)) found.add(category.id); }
    return found;
  };
  const allowed = descendants(roots.map(category => category.id));
  const assignments = (item: CategorizedItem) => item.categoryIds?.length ? item.categoryIds : [item.categoryId];
  return { typed, roots, allowed, path, descendants, assignments };
}
